import { render, staticRenderFns } from "./AppointmentListRealties.vue?vue&type=template&id=02c697f4&scoped=true&"
import script from "./AppointmentListRealties.vue?vue&type=script&lang=js&"
export * from "./AppointmentListRealties.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentListRealties.vue?vue&type=style&index=0&id=02c697f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c697f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
